import { BoothSelectionWidget, ProductUnitSelectionWidget, ShopSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  shop_id: {
    'ui:widget': ShopSelectionWidget,
  },
  booth_id: {
    'ui:widget': BoothSelectionWidget,
  },
  unit_fie_id: {
    'ui:widget': ProductUnitSelectionWidget,
  },
  details: {
    'ui:widget': 'textarea',
  },
});

export default uiSchema;
